module.exports = __webpack_public_path__ + "static/media/megara-icon.342e9d69.png";